import React, { useState, useEffect } from 'react';
import Nav from '../../../hooks/Nav';
import useFormatDate from '../../../hooks/useFormatDate';
import Sort from '../../../tailwindUI/Sort';
import SearchBar from '../../../tailwindUI/SearchBar';
import EmptyState from '../../../tailwindUI/EmptyState';
import Table from '../../../tailwindUI/Table';
import Pagination from '../../../tailwindUI/Pagination';
import usePagination from '../../../tailwindUI/usePagination';
import useSort from '../../../tailwindUI/useSort';
import LongAlert from '../../../tailwindUI/LongAlert';
import useFormatPhoneNumber from '../../../hooks/useFormatPhoneNumber';
import AccentButton from '../../../tailwindUI/AccentButton';
import CircleIconCredentianls from '../../../hooks/CircleIconCredentials';
import { getStages } from '../../../apiClient/operations/stagesOperations';
import { AdjustmentsHorizontalIcon } from '@heroicons/react/24/outline';
import DateIntervalV2 from '../../../tailwindUI/DateIntervalV2';
import useDateInterval from '../../../tailwindUI/useDateInterval';
import SlideOver from '../../../tailwindUI/SlideOver';

const tableColumns = [
    { heading: 'Fecha', value: 'created_formatted' },
    { heading: 'Cliente', value: 'name' },
    { heading: 'Contacto', value: 'email', subvalue: 'phone_number_formated', main: true },
    { heading: 'CIEC', value: 'sat_ciec', align: 'center' },
    { heading: 'eFirma', value: 'sat_efirma', align: 'center' },
    { heading: 'CSF', value: 'tax_status', align: 'center' },
    { heading: '32D', value: 'tax_compliance', align: 'center' },
    { heading: 'Conexión SAT', value: 'sat_connection', align: 'center' }
];
const itemsLimitInTable = 10;

function Prospects() {

    const paginate = usePagination();
    const { formatDate } = useFormatDate();
    const sortItem = useSort();
    const { formatPhoneNumber } = useFormatPhoneNumber();
    const [searchInput, setSearchInput] = useState(null);
    const [sortString, setSortString] = useState('');
    const [pagination, setPagination] = useState(null);
    const [currentPage, setCurrenPage] = useState(1);
    const [accounts, setAccounts] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const dateInterval = useDateInterval();
    const [filterString, setFilterString] = useState('');
    const [filtersApplied, setFiltersApplied] = useState(false);
    const [openSlide, setOpenSlide] = useState(false);
    const [sortOptions, setSortOptions] = useState([
        { id: 1, name: 'Los más nuevos', field: 'created', sort: 'reverse', active: false },
        { id: 2, name: 'Los más antiguos', field: 'created', sort: 'direct', active: false },
        { id: 3, name: 'Nombre descendente', field: 'account.name', sort: 'direct', active: false },
        { id: 4, name: 'Nombre ascendente', field: 'account.name', sort: 'reverse', active: false }
    ]);
    const [intervalsFilter, setIntervalsFilter] = useState(
        {
            id: 1,
            name: 'Fecha de actualización',
            value: 'created',
            open: false
        }
    );

    const handleApplyFilters = () => {
        setFilterString(dateInterval(intervalsFilter));
        setFiltersApplied(true);
    }

    useEffect(() => {
        filtersApplied && handleApplyFilters();
    }, [filtersApplied, intervalsFilter]);

    useEffect(() => {
        if (searchInput == '' || searchInput == null) {
            handleGetAccounts(currentPage, itemsLimitInTable, searchInput, sortString, filterString);
        } else {
            setCurrenPage(1)
            handleGetAccounts(1, itemsLimitInTable, searchInput, sortString, filterString);
        }

    }, [searchInput]);

    useEffect(() => {
        if (filterString == '' || filterString == null) {
            handleGetAccounts(currentPage, itemsLimitInTable, searchInput, sortString, filterString);
        } else {
            setCurrenPage(1)
            handleGetAccounts(1, itemsLimitInTable, searchInput, sortString, filterString);
        }

    }, [filterString]);

    useEffect(() => {
        handleGetAccounts(currentPage, itemsLimitInTable, searchInput, sortString, filterString);
    }, [currentPage, sortString]);

    useEffect(() => {
        filtersApplied == false && setFilterString('')
    }, [filtersApplied]);

    useEffect(() => {
        const activeOptions = sortOptions?.filter(option => option.active);
        if (activeOptions.length > 0) {
            const sortedItem = sortItem(activeOptions[0]);
            setSortString(sortedItem);
        }
    }, [sortOptions]);


    const handleGetAccounts = async (page, limit, search, sort, filters) => {
        setIsLoading(true);
        try {
            const res = await getStages(page, limit, search, sort, ['prospect'], filters);
            // const res = await getAccounts(page, limit, search, sort, ['prospect']);
            setPagination(paginate(res.total_items, itemsLimitInTable, Math.ceil(res.total_items / res.limit)));
            const response = res.data.prospects.map(item => {
                return {
                    ...item,
                    name: (
                        <div className='flex flex-col'>
                            <a href={`/prospects/view/${item.account.id}#info`} className='text-[#0284C7] text-sm font-medium underline underline-offset-2'>
                                {item.account.name}
                            </a>
                            <span className='text-gray-500 text-sm font-normal'>
                                { item.account.taxpayer.tax_id }
                            </span>
                        </div>
                    ),
                    tax_id: item.account.taxpayer.tax_id,
                    id: item.account.id,
                    email: item.account.email,
                    created_formatted: formatDate(item.created, 'DD MMMM YYYY'),
                    phone_number_formated: formatPhoneNumber(item.account.phone_number),
                    sat_ciec: <CircleIconCredentianls item={item.checklist.prospect} name="sat_ciec" />,
                    sat_efirma: <CircleIconCredentianls item={item.checklist.prospect} name="sat_efirma" />,
                    tax_status: <CircleIconCredentianls item={item.checklist.prospect} name="tax_status" />,
                    tax_compliance: <CircleIconCredentianls item={item.checklist.prospect} name="tax_compliance" />,
                    sat_connection: <CircleIconCredentianls item={item.checklist.prospect} name="sat_connection" />,
                }
            });
            setAccounts(response);
            setIsLoading(false);
            // setLoadingCSV(false)
        } catch (e) {
            setAccounts([]);
            setIsLoading(false);
            setError('No se pudieron obtener los prospectos');
        }
    }
    const columnActions = [
        // {
        //     id: 1,
        //     name: 'Visualizar',
        //     type: 'primary',
        //     icon: <DocumentMagnifyingGlassIcon className='w-6 h-6 text-gray-600 lg:text-white' />,
        //     action: handleView,
        // }
    ];

    const seeFullAccountList = () => {
        setCurrenPage(1);
        setSearchInput(null);
        setSortString('');
        setFilterString('')
        setIntervalsFilter({
            ...intervalsFilter,
            start: null,
            end: null,
        })
        setFiltersApplied(false);
    }

    return (
        <>
            <div className="w-full">
                <Nav>
                    <div className="w-full">
                        <span className="text-3xl text-white font-bold">
                            Prospectos
                        </span>
                    </div>
                </Nav>
            </div>
            <div className='min-h-full md:min-h-[calc(100vh-4rem)]'>
                {error &&
                    <div className='w-full sticky top-[68px] md:top-1 mt-20 md:mt-4 z-[35]'>
                        <LongAlert title={error} show={error != null} onClose={() => setError(null)} />
                    </div>
                }
                <div className="w-full px-4 pt-4">
                    <div className="hidden md:flex justify-between items-center w-full">
                        <h1 className="hidden md:block text-4xl font-bold text-left text-gray-900">
                            Prospectos
                        </h1>
                    </div>
                </div>
                <div className={`w-full px-4 py-0 md:py-4 ${error != null ? 'mt-0' : 'mt-16 md:mt-0'} `}>
                    {isLoading ?
                        <>
                            <div className='w-full h-12 rounded-full bg-gray-300 animate-pulse'></div>
                            <div className='w-full flex justify-between'>
                                <div className='w-24 h-6 rounded-full bg-gray-300 animate-pulse my-4' />
                                <div className='w-24 h-6 rounded-full bg-gray-300 animate-pulse my-4' />
                            </div>
                            <Table title='Prospectos' data={accounts} isLoadingData={isLoading} columns={tableColumns} actions={columnActions} />
                        </>
                        :
                        <>
                            {accounts.length > 0 ?
                                <>
                                    <SearchBar value={searchInput} setValue={setSearchInput} placeholder_desktop="Nombre, correo o RFC" />
                                    <section aria-labelledby="filter-heading" className='pt-4'>
                                        <div className="flex items-center justify-between">
                                            <Sort options={sortOptions} title='Ordenar' setOptions={setSortOptions} />
                                            <div className='flex items-center gap-6'>
                                                <button type="button" className="flex items-center gap-1 text-sm font-medium text-gray-700 md:hidden" onClick={() => setOpenSlide(true)}>
                                                    Filtros <span><AdjustmentsHorizontalIcon className='w-[18px] h-[18px]' /></span>
                                                </button>
                                                <div className='hidden md:flex'>
                                                    <DateIntervalV2 filters={intervalsFilter} setFilters={setIntervalsFilter} setFiltersApplied={setFiltersApplied} />
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                    <div className='mt-4'>
                                        <Table title='Prospectos' data={accounts} isLoadingData={isLoading} columns={tableColumns} actions={columnActions} />
                                    </div>
                                    <div className='mt-4'>
                                        <Pagination pages={pagination?.pages?.length} currentPage={currentPage} setCurrentPage={setCurrenPage} />
                                    </div>
                                </>
                                :
                                <>
                                    <div className='mb-4'>
                                        <SearchBar value={searchInput} setValue={setSearchInput} />
                                    </div>
                                    <EmptyState title='No se encontraron prospectos' text='No se encontraron resultados para esta búsqueda, verifica la información o intenta con otra.'>
                                        <div className='mt-6 hidden md:block'>
                                            <AccentButton onClick={seeFullAccountList}>
                                                Ver la lista completa
                                            </AccentButton>
                                        </div>
                                        <div className='mt-6 w-full md:hidden'>
                                            <AccentButton isFullWidth onClick={seeFullAccountList}>
                                                Ver la lista completa
                                            </AccentButton>
                                        </div>
                                    </EmptyState>
                                </>
                            }
                        </>
                    }
                </div>
            </div>

            <SlideOver open={openSlide} setOpen={setOpenSlide} title='Filtros'>
                <DateIntervalV2 filters={intervalsFilter} openSlide={openSlide} setOpenSlide={setOpenSlide} setFilters={setIntervalsFilter} setFiltersApplied={setFiltersApplied} />
            </SlideOver>
        </>
    )
}

export default Prospects;